import cn from 'classnames';

// ─────────────────────────────────────────────
// 通用空状态
// ─────────────────────────────────────────────

interface BlockEmptyStateProps {
  label?: string;
  className?: string;
}

export function BlockEmptyState({ label, className }: BlockEmptyStateProps) {
  return (
    <div className={cn('flex items-center justify-center py-6 text-[13px] text-[#A3A3A3]', className)}>
      {label ? `暂无${label}数据` : '暂无数据'}
    </div>
  );
}
